import React from 'react';
import { Container } from 'reactstrap';

const TrustedBy = () => {
  const partners = [
    {
      name: 'Roba da Donne',
      image: require('../../assets/images/trusted-by/robadadonne.png'),
      link: 'https://salute.robadadonne.it/sos-dottore-medico-vero-in-tasca-h24/',
    },
    {
      name: 'Periodo Fertile',
      image: require('../../assets/images/trusted-by/periodofertile.png'),
      link: 'https://www.periodofertile.it/consigli/sos-dottore-il-medico-sempre-con-te-a-portata-di-smartphone',
    },
    {
      name: 'Mamma che App',
      image: require('../../assets/images/trusted-by/mammacheapp.png'),
      link: 'https://www.mammacheapp.it',
    },
    {
      name: 'Gravidanza Online',
      image: require('../../assets/images/trusted-by/gravidanzaonline.png'),
      link: 'https://www.gravidanzaonline.it/news/sos-dottore-online-h24',
    },
    {
      name: 'iMamma',
      image: require('../../assets/images/trusted-by/imamma.png'),
      link: 'https://www.imamma.it/',
    },
    {
      name: 'Vita da Mamma',
      image: require('../../assets/images/trusted-by/vitadamamma.png'),
      link: 'https://www.vitadamamma.com/204383/sos-dottore-il-servizio-digitale-che-porta-il-medico-a-casa-tua-anche-online.html',
    },
  ];

  return (
    <section className="trusted-by">
      <Container>
        <div className="trusted-by__header">
          <h3 className="text-center">Parlano di noi</h3>
        </div>
        <div className="trusted-by__logos">
          <div className="logo-grid">
            {partners.map((partner, index) => (
              <div key={index} className="logo-item">
                <a
                  href={partner.link}
                  target="_blank"
                  rel="noopener noreferrer">
                  <img src={partner.image} alt={partner.name} />
                </a>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
};

export default TrustedBy;
